import { render } from "./YouView.vue?vue&type=template&id=d97ebcaa&scoped=true"
import script from "./YouView.vue?vue&type=script&lang=js"
export * from "./YouView.vue?vue&type=script&lang=js"

import "./YouView.vue?vue&type=style&index=0&id=d97ebcaa&scoped=true&lang=css"

import exportComponent from "/home/oat/Desktop/ordi/corridor_v2/corridor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d97ebcaa"]])

export default __exports__